import RedeemIcon from '@mui/icons-material/Redeem'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { Grid2, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import DefaultLayout from 'components/layout/DefaultLayout'
import { redeemVoucherPath, voucherFlowPath } from 'components/Routes/Routes'
import { useNavigate } from 'react-router-dom'
import useStyles from './styles'

export default function Gifts(): JSX.Element {
  const { classes } = useStyles()
  const navigate = useNavigate()

  return (
    <DefaultLayout backgroundColor='white' wrapperContent={{ mt: 0, mb: 2 }}>
      <Grid2 container rowSpacing={2} py={4}>
        <Grid2 size={{ xs: 12 }}>
          <Box
            className={classes.fancyButton}
            onClick={() => navigate(voucherFlowPath())}
          >
            <Box>{<ShoppingCartIcon />}</Box>
            <Typography variant='h4'>Buy Gift</Typography>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12 }}>
          <Box
            className={classes.fancyButton}
            onClick={() => navigate(redeemVoucherPath())}
          >
            <Box>{<RedeemIcon />}</Box>
            <Typography variant='h4'>Redeem Gift</Typography>
          </Box>
        </Grid2>
      </Grid2>
    </DefaultLayout>
  )
}
